import { IReqInform } from 'src/types/informTypes';
import { Api } from '../config';

export const informServiceProvider = () => {
  /**
   * 傳送資料錯誤通報。
   */
  const sendInformMail = async (params: IReqInform) => {
    await Api().post('/userReport/dataset', params);
  };

  return {
    sendInformMail,
  };
};
